import React from "react";
import Typewriter from "typewriter-effect";
//https://www.npmjs.com/package/typewriter-effect

export default function About() {
	return (
		<section id="about">
			<Typewriter
				id="intro"
				options={{
					autoStart: true,
					cursor: "",
					delay: 75,
				}}
				onInit={(typewriter) => {
					typewriter.typeString("<h1>Hey there, I'm Giulia</h1>").start();
				}}
			/>

			<Typewriter
				id="intro"
				options={{
					autoStart: true,
					cursor: "",
					loop: false,
					delay: 75,
					deleteSpeed: 1,
				}}
				onInit={(typewriter) => {
					typewriter
						.pauseFor(2000)
						.typeString(`I was a structural engineer`)
						.pauseFor(100)
						.deleteChars(25)
						.typeString('am a self-taught <span id="introHighlight"> front-end </span>')
						.deleteChars(12)
						.typeString(
							'<span id="introHighlight"> full-stack developer </span> who loves learning.',
						)
						.pauseFor(100)
						.start();
				}}
			/>
			<p id="intro-par">
				<div className="work">
					I'm driven by curiosity and am passionate about front-end development and UX/UI design,
					especially when there’s a chance to push my skills forward. I'm currently learning
					full-stack development with Node.js.
				</div>
				<div className="personal">
					Outside of work, you'll usually find me reading, sketching, or learning a new language
					(今は、日本語が大好きです！). Most likely, with a hot cup of caffeine in hand.
				</div>
			</p>
			<div id="intro-buttons-cont">
				<button>
					<a href="#contact-me">Contact me</a>
				</button>
				<button>
					<a href="#projects">Check out my projects</a>
				</button>
			</div>
		</section>
	);
}
